export default __webpack_public_path__ + "static/smartservice-1dd0f91222f8f4b57246c667a8648ba0.png";